export default class TelcoHeaderEnrichment {

  static process(callback) {
    if(window.subdomainTelkomsel == undefined) {
      callback();
      return;
    }

    $.ajax({
      type: 'GET',
      url: window.subdomainTelkomsel + '/telcos/he'
    }).done(function(resp) {
      TelcoHeaderEnrichment.onHeSuccessSetCookieWatch(resp, callback);
    }).fail(function() {
      callback();
    });
  }

  static onHeSuccessSetCookieWatch(resp, callback){
    var data = resp.result;
    if (data) {
      TelcoHeaderEnrichment.setCookieWatch(data, callback);
    } else {
      callback();
    }
  }

  static setCookieWatch(data, callback) {
    $.ajax({
      type: 'POST',
      url: '/telcos/she',
      data: { 'data' : data }
    }).always(function() {
      callback();
    });
  }

  static smartFill(callback) {
    if(window.subdomainTelkomsel == undefined) {
      callback();
      return;
    }

    $.ajax({
      type: 'GET',
      url: window.subdomainTelkomsel + '/telcos/he'
    }).done(function(resp) {
      TelcoHeaderEnrichment.onHeSuccessPhe(resp, callback,
        TelcoHeaderEnrichment.phe);
    }).fail(function() {
      callback();
    });
  }

  static onHeSuccessPhe(resp, callback){
    var data = resp.result;
    if (data) {
      TelcoHeaderEnrichment.phe(data, callback);
    } else {
      callback();
    }
  }

  static phe(data, callback) {
    $.ajax({
      type: 'POST',
      url: '/telcos/phe',
      data: { 'data' : data }
    }).done(function(resp) {
      callback(resp.result);
    }).fail(function() {
      callback();
    });
  }
}
